import { Button, useI18n, Modal } from '@ywwwtseng/react-kit';
import { Typography, openTelegramLink } from '@ywwwtseng/tma-react-kit';
import { Chat } from './Chat';
import type { SelectTgChat } from '@/types';

interface JoinChatModalProps {
  open: boolean;
  onClose: () => void;
  tg_chat: SelectTgChat | null | undefined;
}

export function JoinChatModal({ open, onClose, tg_chat }: JoinChatModalProps) {
  const { t } = useI18n();

  const handleJoin = () => {
    if (tg_chat) {
      if (tg_chat.invite_link) {
        openTelegramLink(tg_chat.invite_link);
      } else if (tg_chat.username) {
        openTelegramLink(`https://t.me/${tg_chat.username}`);
      }
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('common.join_chat_to_earn')}
      classes={{
        content: 'border-1 border-gray-700/10 md:max-w-[400px] md:mx-auto'
      }}
    >

      <Typography size="2" whitespacePreWrap>
        {t('join_chat_modal.title')}
      </Typography>

      <Typography size="1" whitespacePreWrap>{t('join_chat_modal.description')}</Typography>

      {tg_chat && (
        <div className="flex flex-col gap-2">
          <Chat card={false} chat={tg_chat} direction="vertical" />
        </div>
      )}

      <div className="flex flex-col gap-2 w-full px-4">
        <Button
          width="full"
          color="primary"
          variant="contained"
          size="sm"
          rounded="full"
          onClick={handleJoin}
        >
          {t('common.join') || 'Join Group'}
        </Button>
      </div>

    </Modal>
  );
}
